export const productDataBikinis = [
    
    {
      id: "1Bikinidospiezascolaless",
      imageurl:
        "https://http2.mlstatic.com/D_NQ_NP_667786-MLA52596554678_112022-W.webp",
      name: "Bikini 2 piezas colaless",
      price: "3600",
      description: "bikinis",
      color: "yellow",      
      IsTalla: "Talla",
      IsSale: "Sale",
      signo: "$",
      pricebefore: "4000",
      colorbc: "pink",
      tallas: [ 1,2,3 ], 
      quantity: 1,
    },
    {
      id: "2Bikinidospiezastirascruzadas",
      imageurl:
      'https://res.cloudinary.com/dvjmjujc0/image/upload/v1692992050/bikini2cruzado_jtlclq.webp',
      name: "Bikini 2 piezas tiras cruzadas",
      price: "4200",
      description: "bikinis",
      color: "white",      
      IsSale: "Nuevo",
      colorbc: "pink",
      tallas: [ 1,2 ], 
      quantity: 1,
    },
    {
      id: "3Bikinidospiezastiroalto",
      imageurl:
        "https://http2.mlstatic.com/D_NQ_NP_717017-MLA52388704265_112022-W.webp",
      name: "Bikini 2 piezas tiro alto",
      price: "6000",
      description: "bikinis",
      color: "nute",      
      IsTalla: "Talla",
      tallas: [ 1,2 ], 
      quantity: 1,
    },
    {
      id: "4Bikinitrespiezasconpareo",
      imageurl:
        "https://http2.mlstatic.com/D_NQ_NP_676135-MLA48012810909_102021-W.webp",
      name: "Bikini 3 piezas con pareo",
      price: "10000",
      description: "bikinis",
      color: "jean",      
      IsTalla: "Talla",
      tallas: [ 1,2, 3, 4 ], 
      quantity: 1,
    },
    {
      id: "5Enterizoconmedioestilomalla",
      imageurl:
        "https://http2.mlstatic.com/D_NQ_NP_698423-MLA52624938958_112022-W.webp",
      name: "Enterizo con medio estilo malla",
      price: "11000",
      description: "bikinis",
      color: "red",      
      IsTalla: "Talla",
      tallas: [ 3, 4 , 5], 
      quantity: 1,
    },
    {
      id: "6Bikinidospiezasestampado",
      imageurl:
        "https://res.cloudinary.com/dvjmjujc0/image/upload/v1692992757/bikiniestampado_unvdk4.webp",
      name: "Bikini 2 piezas estampado",
      price: "6500",
      description: "bikinis",
      color: "black",       
      IsTalla: "Talla",
      tallas: [ 3,4,5 ],
      quantity: 1,
    },
    {
      id: "7Bikinidospiezascruzadoalhombro",
      imageurl:
        "https://http2.mlstatic.com/D_NQ_NP_674356-MLA51522207725_092022-W.webp",
      name: "Bikini 2 piezas cruzado al hombro",
      price: "6000",
      description: "bikinis",
      color: 'red',
      tallas: [1,2,3 ],
      quantity: 1,
    },
    {
      id: "8Bikinitrespiezasconpareo",
      imageurl:
        "https://http2.mlstatic.com/D_NQ_NP_870584-MLA52466342030_112022-W.webp",
      name: "Bikini 3 piezas con pareo",
      price: "13000",
      description: "bikinis",
      color: "green-dark",
      IsTalla: "Talla",
      tallas: [ 2,3,4 ],
      quantity: 1,
    },
  ];